module.exports = __webpack_public_path__ + "static/media/scr_onboarding_01.9ef1ee71.png";